import { checkNum10 } from "./CheckLogic";

export const PeriodTypeChange = (data1, data2) => {
  // period에 따른 from 날짜 리턴
  // data1 : 년도, 월, 일 data2 : 기간
  let date = new Date();
  
  // n달 전
  // 사파리 처리 (2023/02/09 00:00:00)
  if(data1 === "year") {
    date.setFullYear(date.getFullYear() - data2);
  } else if(data1 === "month") {
    date.setMonth((date.getMonth() - data2));
  } else {
    date.setDate(date.getDate() - data2);
  }
  
  return date
}

export const convertFormat = (date, format) => {
  const originDate = date;
  let returnDate;

  if(format === "yyyyMMdd") {
    returnDate = originDate.getFullYear().toString() + checkNum10((originDate.getMonth() + 1).toString()) +  checkNum10(originDate.getDate().toString());
  }

  if(format === "yyyy.MM.dd") {
    returnDate = originDate.getFullYear().toString() + "." + checkNum10((originDate.getMonth() + 1).toString()) + "." +  checkNum10(originDate.getDate().toString());
  }
  
  if(format === "yyyy-MM-dd") {
    returnDate = originDate.getFullYear().toString() + "-" + checkNum10((originDate.getMonth() + 1).toString()) + "-" +  checkNum10(originDate.getDate().toString());
  }

  return returnDate
}

export const convertFormatString = (dateParam, format) => {
  const originDate = dateParam;

  const year = originDate.substring(0, 4);
  const month = originDate.substring(4, 6);
  const date = originDate.substring(6, 8);

  let returnDate;

  if(format === "yyyyMMdd") {
    returnDate = year + month + date;
  }

  if(format === "yyyy.MM.dd") {
    returnDate = year + "." + month + "." +  date;
  }
  
  if(format === "yyyy-MM-dd") {
    returnDate = year + "-" + month + "-" +  date;
  }

  return returnDate
}